import { IdolRank } from '../types';
export interface CityData {
  name: string;
  connections: string[];
  facilities: string[];
  minRank: IdolRank;
  difficultyMultiplier: number;
  population: number;
  distanceFromSeoul: number;
}

export const CITIES: Record<string, CityData> = {
  'SEOUL': {
    name: 'Seoul',
    connections: ["OSAKA"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.TRAINEE,
    difficultyMultiplier: 1.0,
    population: 9776000,
    distanceFromSeoul: 0
  },
  'OSAKA': {
    name: 'Osaka',
    connections: ["SEOUL", "SHANGHAI"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.TRAINEE,
    difficultyMultiplier: 1.7,
    population: 18967459,
    distanceFromSeoul: 830
  },
  'SHANGHAI': {
    name: 'Shanghai',
    connections: ["BEIJING", "SEOUL", "OSAKA"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.TRAINEE,
    difficultyMultiplier: 1.7,
    population: 29870000,
    distanceFromSeoul: 868
  },
  'BEIJING': {
    name: 'Beijing',
    connections: ["TOKYO", "SEOUL", "SHANGHAI"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.TRAINEE,
    difficultyMultiplier: 1.8,
    population: 22189082,
    distanceFromSeoul: 952
  },
  'TOKYO': {
    name: 'Tokyo',
    connections: ["TAIPEI", "BEIJING", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.ROOKIE,
    difficultyMultiplier: 1.9,
    population: 37115035,
    distanceFromSeoul: 1153
  },
  'TAIPEI': {
    name: 'Taipei',
    connections: ["MACAU", "TOKYO", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.ROOKIE,
    difficultyMultiplier: 2.2,
    population: 7047000,
    distanceFromSeoul: 1463
  },
  'MACAU': {
    name: 'Macau',
    connections: ["HONG_KONG", "TAIPEI", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 2.6,
    population: 695000,
    distanceFromSeoul: 2000
  },
  'HONG_KONG': {
    name: 'Hong Kong',
    connections: ["MACAU", "ULAANBAATAR", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 2.7,
    population: 7480000,
    distanceFromSeoul: 2093
  },
  'ULAANBAATAR': {
    name: 'Ulaanbaatar',
    connections: ["MANILA", "HONG_KONG", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 2.7,
    population: 1540000,
    distanceFromSeoul: 2135
  },
  'MANILA': {
    name: 'Manila',
    connections: ["HANOI", "ULAANBAATAR", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 3.1,
    population: 14406000,
    distanceFromSeoul: 2595
  },
  'HANOI': {
    name: 'Hanoi',
    connections: ["MANILA", "SEOUL", "VIENTIANE"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 3.2,
    population: 8053000,
    distanceFromSeoul: 2716
  },
  'VIENTIANE': {
    name: 'Vientiane',
    connections: ["HO_CHI_MINH_CITY", "HANOI", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 3.6,
    population: 948000,
    distanceFromSeoul: 3200
  },
  'HO_CHI_MINH_CITY': {
    name: 'Ho Chi Minh City',
    connections: ["PHNOM_PENH", "SEOUL", "VIENTIANE"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 3.7,
    population: 8993000,
    distanceFromSeoul: 3420
  },
  'PHNOM_PENH': {
    name: 'Phnom Penh',
    connections: ["BANGKOK", "HO_CHI_MINH_CITY", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 3.8,
    population: 2281000,
    distanceFromSeoul: 3480
  },
  'BANGKOK': {
    name: 'Bangkok',
    connections: ["PHNOM_PENH", "YANGON", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 4.0,
    population: 10900000,
    distanceFromSeoul: 3722
  },
  'YANGON': {
    name: 'Yangon',
    connections: ["BANGKOK", "DHAKA", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 4.0,
    population: 5572000,
    distanceFromSeoul: 3740
  },
  'DHAKA': {
    name: 'Dhaka',
    connections: ["YANGON", "THIMPHU", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 4.2,
    population: 23936000,
    distanceFromSeoul: 4010
  },
  'THIMPHU': {
    name: 'Thimphu',
    connections: ["SEOUL", "DHAKA", "ALMATY"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 4.3,
    population: 115000,
    distanceFromSeoul: 4150
  },
  'ALMATY': {
    name: 'Almaty',
    connections: ["KATHMANDU", "THIMPHU", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 4.4,
    population: 2100000,
    distanceFromSeoul: 4200
  },
  'KATHMANDU': {
    name: 'Kathmandu',
    connections: ["BISHKEK", "ALMATY", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 4.4,
    population: 1442000,
    distanceFromSeoul: 4300
  },
  'BISHKEK': {
    name: 'Bishkek',
    connections: ["KUALA_LUMPUR", "KATHMANDU", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 4.6,
    population: 1074000,
    distanceFromSeoul: 4480
  },
  'KUALA_LUMPUR': {
    name: 'Kuala Lumpur',
    connections: ["BISHKEK", "SINGAPORE", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 4.7,
    population: 8600000,
    distanceFromSeoul: 4600
  },
  'SINGAPORE': {
    name: 'Singapore',
    connections: ["KUALA_LUMPUR", "SEOUL", "DELHI"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 4.7,
    population: 5917000,
    distanceFromSeoul: 4627
  },
  'DELHI': {
    name: 'Delhi',
    connections: ["SINGAPORE", "TASHKENT", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.IDOL,
    difficultyMultiplier: 4.7,
    population: 33807000,
    distanceFromSeoul: 4670
  },
  'TASHKENT': {
    name: 'Tashkent',
    connections: ["DUSHANBE", "SEOUL", "DELHI"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 5.0,
    population: 2970000,
    distanceFromSeoul: 5050
  },
  'DUSHANBE': {
    name: 'Dushanbe',
    connections: ["ISLAMABAD", "TASHKENT", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 5.1,
    population: 880000,
    distanceFromSeoul: 5100
  },
  'ISLAMABAD': {
    name: 'Islamabad',
    connections: ["DUSHANBE", "JAKARTA", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 5.2,
    population: 1210000,
    distanceFromSeoul: 5200
  },
  'JAKARTA': {
    name: 'Jakarta',
    connections: ["ISLAMABAD", "SEOUL", "KABUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 5.2,
    population: 34540000,
    distanceFromSeoul: 5280
  },
  'KABUL': {
    name: 'Kabul',
    connections: ["JAKARTA", "SEOUL", "MUMBAI"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 5.4,
    population: 4600000,
    distanceFromSeoul: 5500
  },
  'MUMBAI': {
    name: 'Mumbai',
    connections: ["CHENNAI", "SEOUL", "KABUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 5.5,
    population: 21673000,
    distanceFromSeoul: 5580
  },
  'CHENNAI': {
    name: 'Chennai',
    connections: ["ASHGABAT", "SEOUL", "MUMBAI"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 5.5,
    population: 11500000,
    distanceFromSeoul: 5600
  },
  'ASHGABAT': {
    name: 'Ashgabat',
    connections: ["CHENNAI", "BANGALORE", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 5.5,
    population: 1030000,
    distanceFromSeoul: 5600
  },
  'BANGALORE': {
    name: 'Bangalore',
    connections: ["COLOMBO", "ASHGABAT", "SEOUL"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 5.6,
    population: 13200000,
    distanceFromSeoul: 5700
  },
  'COLOMBO': {
    name: 'Colombo',
    connections: ["BANGALORE", "SEOUL", "KARACHI"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 5.6,
    population: 752000,
    distanceFromSeoul: 5800
  },
  'KARACHI': {
    name: 'Karachi',
    connections: ["COLOMBO", "SEOUL", "MALE"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 5.8,
    population: 17140000,
    distanceFromSeoul: 6000
  },
  'TEHRAN': {
    name: 'Tehran',
    connections: ["DUBAI"],
    facilities: ["ST", "CA", "MS", "RL", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 6.0,
    population: 9500000,
    distanceFromSeoul: 6200
  },
  'MALE': {
    name: 'Malé',
    connections: ["SEOUL", "KARACHI"],
    facilities: ["PR", "ST", "VS", "CA", "HC", "SC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 6.0,
    population: 252000,
    distanceFromSeoul: 6300
  },
  'MOSCOW': {
    name: 'Moscow',
    connections: ["ST_PETERSBURG"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 6.3,
    population: 12600000,
    distanceFromSeoul: 6620
  },
  'DUBAI': {
    name: 'Dubai',
    connections: ["TEHRAN", "ABU_DHABI", "SEOUL"],
    facilities: ["ST", "CA", "MS", "RL", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 6.4,
    population: 3600000,
    distanceFromSeoul: 6788
  },
  'ST_PETERSBURG': {
    name: 'St. Petersburg',
    connections: ["HELSINKI", "MOSCOW"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 6.4,
    population: 5400000,
    distanceFromSeoul: 6800
  },
  'ABU_DHABI': {
    name: 'Abu Dhabi',
    connections: ["DUBAI", "MUSCAT"],
    facilities: ["ST", "CA", "MS", "RL", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 6.5,
    population: 1500000,
    distanceFromSeoul: 6850
  },
  'MUSCAT': {
    name: 'Muscat',
    connections: ["ABU_DHABI", "MANAMA"],
    facilities: ["ST", "CA", "MS", "RL", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 6.5,
    population: 1550000,
    distanceFromSeoul: 6900
  },
  'MANAMA': {
    name: 'Manama',
    connections: ["DOHA", "MUSCAT"],
    facilities: ["ST", "CA", "MS", "RL", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 6.6,
    population: 580000,
    distanceFromSeoul: 7050
  },
  'HELSINKI': {
    name: 'Helsinki',
    connections: ["ST_PETERSBURG", "TALLINN"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 6.7,
    population: 1320000,
    distanceFromSeoul: 7100
  },
  'DOHA': {
    name: 'Doha',
    connections: ["MANAMA", "RIYADH"],
    facilities: ["ST", "CA", "MS", "RL", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 6.7,
    population: 2380000,
    distanceFromSeoul: 7130
  },
  'RIYADH': {
    name: 'Riyadh',
    connections: ["BAGHDAD", "DOHA"],
    facilities: ["ST", "CA", "MS", "RL", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 6.8,
    population: 7680000,
    distanceFromSeoul: 7200
  },
  'TALLINN': {
    name: 'Tallinn',
    connections: ["HELSINKI", "KIEV"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 6.8,
    population: 440000,
    distanceFromSeoul: 7200
  },
  'BAGHDAD': {
    name: 'Baghdad',
    connections: ["RIYADH", "KUWAIT_CITY"],
    facilities: ["ST", "CA", "MS", "RL", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 6.8,
    population: 7511000,
    distanceFromSeoul: 7300
  },
  'HONOLULU': {
    name: 'Honolulu',
    connections: ["PERTH"],
    facilities: ["ST", "CA", "MS", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 6.8,
    population: 350000,
    distanceFromSeoul: 7300
  },
  'KUWAIT_CITY': {
    name: 'Kuwait City',
    connections: ["BAGHDAD", "JEDDAH"],
    facilities: ["ST", "CA", "MS", "RL", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 6.9,
    population: 3100000,
    distanceFromSeoul: 7350
  },
  'JEDDAH': {
    name: 'Jeddah',
    connections: ["SANNA", "KUWAIT_CITY"],
    facilities: ["ST", "CA", "MS", "RL", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.0,
    population: 4700000,
    distanceFromSeoul: 7500
  },
  'KIEV': {
    name: 'Kiev',
    connections: ["TALLINN", "RIGA"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.0,
    population: 2950000,
    distanceFromSeoul: 7500
  },
  'RIGA': {
    name: 'Riga',
    connections: ["KIEV", "VILNIUS"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.0,
    population: 620000,
    distanceFromSeoul: 7500
  },
  'VILNIUS': {
    name: 'Vilnius',
    connections: ["MINSK", "RIGA"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.0,
    population: 590000,
    distanceFromSeoul: 7550
  },
  'SANNA': {
    name: 'Sana\'a',
    connections: ["JEDDAH", "ADEN"],
    facilities: ["ST", "CA", "MS", "RL", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.1,
    population: 3900000,
    distanceFromSeoul: 7600
  },
  'MINSK': {
    name: 'Minsk',
    connections: ["STOCKHOLM", "VILNIUS"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.1,
    population: 2000000,
    distanceFromSeoul: 7600
  },
  'STOCKHOLM': {
    name: 'Stockholm',
    connections: ["MINSK", "ANKARA"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.2,
    population: 980000,
    distanceFromSeoul: 7700
  },
  'ADEN': {
    name: 'Aden',
    connections: ["AMMAN", "SANNA"],
    facilities: ["ST", "CA", "MS", "RL", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.2,
    population: 1000000,
    distanceFromSeoul: 7800
  },
  'ANKARA': {
    name: 'Ankara',
    connections: ["WARSAW", "STOCKHOLM"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.2,
    population: 5700000,
    distanceFromSeoul: 7800
  },
  'PERTH': {
    name: 'Perth',
    connections: ["BRISBANE", "HONOLULU"],
    facilities: ["ST", "CA", "MS", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.2,
    population: 2200000,
    distanceFromSeoul: 7800
  },
  'AMMAN': {
    name: 'Amman',
    connections: ["DAMASCUS", "ADEN"],
    facilities: ["ST", "CA", "MS", "RL", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.3,
    population: 4300000,
    distanceFromSeoul: 7850
  },
  'DAMASCUS': {
    name: 'Damascus',
    connections: ["BEIRUT", "AMMAN"],
    facilities: ["ST", "CA", "MS", "RL", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.3,
    population: 2500000,
    distanceFromSeoul: 7900
  },
  'WARSAW': {
    name: 'Warsaw',
    connections: ["ISTANBUL", "ANKARA"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.3,
    population: 1790000,
    distanceFromSeoul: 7900
  },
  'BEIRUT': {
    name: 'Beirut',
    connections: ["DAMASCUS", "TEL_AVIV"],
    facilities: ["ST", "CA", "MS", "RL", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.4,
    population: 2450000,
    distanceFromSeoul: 7950
  },
  'ISTANBUL': {
    name: 'Istanbul',
    connections: ["WARSAW", "BUCHAREST"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.4,
    population: 15840000,
    distanceFromSeoul: 7990
  },
  'TEL_AVIV': {
    name: 'Tel Aviv',
    connections: ["BEIRUT"],
    facilities: ["ST", "CA", "MS", "RL", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.4,
    population: 4460000,
    distanceFromSeoul: 8000
  },
  'BRISBANE': {
    name: 'Brisbane',
    connections: ["PERTH", "SYDNEY"],
    facilities: ["ST", "CA", "MS", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.4,
    population: 2600000,
    distanceFromSeoul: 8000
  },
  'BUCHAREST': {
    name: 'Bucharest',
    connections: ["ISTANBUL", "OSLO"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.4,
    population: 1800000,
    distanceFromSeoul: 8050
  },
  'OSLO': {
    name: 'Oslo',
    connections: ["BUCHAREST", "BERLIN"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.5,
    population: 1070000,
    distanceFromSeoul: 8100
  },
  'BERLIN': {
    name: 'Berlin',
    connections: ["OSLO", "COPENHAGEN"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.5,
    population: 3700000,
    distanceFromSeoul: 8132
  },
  'COPENHAGEN': {
    name: 'Copenhagen',
    connections: ["SOFIA", "BERLIN"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.6,
    population: 1370000,
    distanceFromSeoul: 8200
  },
  'VANCOUVER': {
    name: 'Vancouver',
    connections: ["LOS_ANGELES"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.6,
    population: 2600000,
    distanceFromSeoul: 8200
  },
  'SOFIA': {
    name: 'Sofia',
    connections: ["BUDAPEST", "COPENHAGEN"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.6,
    population: 1260000,
    distanceFromSeoul: 8200
  },
  'BUDAPEST': {
    name: 'Budapest',
    connections: ["BELGRADE", "SOFIA"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.6,
    population: 1750000,
    distanceFromSeoul: 8280
  },
  'SYDNEY': {
    name: 'Sydney',
    connections: ["BRISBANE", "MELBOURNE"],
    facilities: ["ST", "CA", "MS", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.7,
    population: 5557233,
    distanceFromSeoul: 8329
  },
  'BELGRADE': {
    name: 'Belgrade',
    connections: ["BUDAPEST", "MUNICH"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.7,
    population: 1400000,
    distanceFromSeoul: 8350
  },
  'MUNICH': {
    name: 'Munich',
    connections: ["BELGRADE", "VIENNA"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.7,
    population: 1500000,
    distanceFromSeoul: 8400
  },
  'VIENNA': {
    name: 'Vienna',
    connections: ["MUNICH", "ATHENS"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.7,
    population: 1900000,
    distanceFromSeoul: 8400
  },
  'CAIRO': {
    name: 'Cairo',
    connections: ["DUBAI", "ALEXANDRIA"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.7,
    population: 22623874,
    distanceFromSeoul: 8431
  },
  'ATHENS': {
    name: 'Athens',
    connections: ["VIENNA", "PRAGUE"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.8,
    population: 3150000,
    distanceFromSeoul: 8500
  },
  'ALEXANDRIA': {
    name: 'Alexandria',
    connections: ["TRIPOLI", "CAIRO"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.8,
    population: 5500000,
    distanceFromSeoul: 8500
  },
  'PRAGUE': {
    name: 'Prague',
    connections: ["ATHENS", "FRANKFURT"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.8,
    population: 1310000,
    distanceFromSeoul: 8550
  },
  'MELBOURNE': {
    name: 'Melbourne',
    connections: ["SYDNEY", "AUCKLAND"],
    facilities: ["ST", "CA", "MS", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.9,
    population: 5078000,
    distanceFromSeoul: 8566
  },
  'FRANKFURT': {
    name: 'Frankfurt',
    connections: ["AMSTERDAM", "PRAGUE"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 7.9,
    population: 760000,
    distanceFromSeoul: 8600
  },
  'AMSTERDAM': {
    name: 'Amsterdam',
    connections: ["BRUSSELS", "FRANKFURT"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.0,
    population: 1160000,
    distanceFromSeoul: 8700
  },
  'BRUSSELS': {
    name: 'Brussels',
    connections: ["AMSTERDAM", "ZURICH"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.0,
    population: 2100000,
    distanceFromSeoul: 8730
  },
  'ZURICH': {
    name: 'Zurich',
    connections: ["LONDON", "BRUSSELS"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.0,
    population: 440000,
    distanceFromSeoul: 8800
  },
  'LONDON': {
    name: 'London',
    connections: ["NEW_YORK", "ZURICH", "MILAN"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.1,
    population: 9100000,
    distanceFromSeoul: 8875
  },
  'MILAN': {
    name: 'Milan',
    connections: ["LONDON", "GENEVA"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.1,
    population: 3200000,
    distanceFromSeoul: 8900
  },
  'GENEVA': {
    name: 'Geneva',
    connections: ["ROME", "MILAN"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.1,
    population: 500000,
    distanceFromSeoul: 8900
  },
  'ROME': {
    name: 'Rome',
    connections: ["PARIS", "GENEVA"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.2,
    population: 4400000,
    distanceFromSeoul: 8966
  },
  'PARIS': {
    name: 'Paris',
    connections: ["LYON", "ROME"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.2,
    population: 13171000,
    distanceFromSeoul: 8966
  },
  'TRIPOLI': {
    name: 'Tripoli',
    connections: ["KHARTOUM", "ALEXANDRIA"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.2,
    population: 1170000,
    distanceFromSeoul: 9050
  },
  'LYON': {
    name: 'Lyon',
    connections: ["MANCHESTER", "PARIS"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.3,
    population: 1700000,
    distanceFromSeoul: 9100
  },
  'MANCHESTER': {
    name: 'Manchester',
    connections: ["LYON", "DUBLIN"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.3,
    population: 2800000,
    distanceFromSeoul: 9100
  },
  'DUBLIN': {
    name: 'Dublin',
    connections: ["BARCELONA", "MANCHESTER"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.3,
    population: 1450000,
    distanceFromSeoul: 9100
  },
  'KHARTOUM': {
    name: 'Khartoum',
    connections: ["TRIPOLI", "TUNIS"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.3,
    population: 6200000,
    distanceFromSeoul: 9100
  },
  'TUNIS': {
    name: 'Tunis',
    connections: ["ADDIS_ABABA", "KHARTOUM"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.4,
    population: 2400000,
    distanceFromSeoul: 9200
  },
  'ADDIS_ABABA': {
    name: 'Addis Ababa',
    connections: ["ALGIERS", "TUNIS"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.5,
    population: 5400000,
    distanceFromSeoul: 9400
  },
  'ALGIERS': {
    name: 'Algiers',
    connections: ["ADDIS_ABABA", "MOGADISHU"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.6,
    population: 3900000,
    distanceFromSeoul: 9500
  },
  'AUCKLAND': {
    name: 'Auckland',
    connections: ["MELBOURNE", "WELLINGTON"],
    facilities: ["ST", "CA", "MS", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.7,
    population: 1710000,
    distanceFromSeoul: 9565
  },
  'LOS_ANGELES': {
    name: 'Los Angeles',
    connections: ["CHICAGO", "VANCOUVER"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.7,
    population: 12500000,
    distanceFromSeoul: 9586
  },
  'WELLINGTON': {
    name: 'Wellington',
    connections: ["AUCKLAND"],
    facilities: ["ST", "CA", "MS", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.8,
    population: 420000,
    distanceFromSeoul: 9750
  },
  'BARCELONA': {
    name: 'Barcelona',
    connections: ["MADRID", "DUBLIN"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.8,
    population: 5600000,
    distanceFromSeoul: 9800
  },
  'MOGADISHU': {
    name: 'Mogadishu',
    connections: ["ALGIERS", "CASABLANCA"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 8.8,
    population: 2590000,
    distanceFromSeoul: 9800
  },
  'MADRID': {
    name: 'Madrid',
    connections: ["BARCELONA", "LISBON"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.SUPERSTAR,
    difficultyMultiplier: 9.0,
    population: 6800000,
    distanceFromSeoul: 9965
  },
  'CASABLANCA': {
    name: 'Casablanca',
    connections: ["NAIROBI", "MOGADISHU"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 9.2,
    population: 3750000,
    distanceFromSeoul: 10200
  },
  'NAIROBI': {
    name: 'Nairobi',
    connections: ["MARRAKECH", "CASABLANCA"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 9.2,
    population: 5100000,
    distanceFromSeoul: 10200
  },
  'LISBON': {
    name: 'Lisbon',
    connections: ["MADRID"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 9.3,
    population: 2900000,
    distanceFromSeoul: 10400
  },
  'MARRAKECH': {
    name: 'Marrakech',
    connections: ["NAIROBI", "KAMPALA"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 9.3,
    population: 1060000,
    distanceFromSeoul: 10400
  },
  'KAMPALA': {
    name: 'Kampala',
    connections: ["MARRAKECH", "PORT_LOUIS"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 9.3,
    population: 3650000,
    distanceFromSeoul: 10400
  },
  'PORT_LOUIS': {
    name: 'Port Louis',
    connections: ["DAR_ES_SALAAM", "KAMPALA"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 9.4,
    population: 150000,
    distanceFromSeoul: 10500
  },
  'CHICAGO': {
    name: 'Chicago',
    connections: ["LOS_ANGELES", "TORONTO"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 9.4,
    population: 9500000,
    distanceFromSeoul: 10550
  },
  'TORONTO': {
    name: 'Toronto',
    connections: ["MONTREAL", "CHICAGO"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 9.5,
    population: 6500000,
    distanceFromSeoul: 10650
  },
  'DAR_ES_SALAAM': {
    name: 'Dar es Salaam',
    connections: ["ANTANANARIVO", "PORT_LOUIS"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 9.6,
    population: 7400000,
    distanceFromSeoul: 10700
  },
  'MONTREAL': {
    name: 'Montreal',
    connections: ["NEW_YORK", "TORONTO"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 9.6,
    population: 4300000,
    distanceFromSeoul: 10800
  },
  'ANTANANARIVO': {
    name: 'Antananarivo',
    connections: ["LUSAKA", "DAR_ES_SALAAM"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 9.7,
    population: 3700000,
    distanceFromSeoul: 10900
  },
  'NEW_YORK': {
    name: 'New York',
    connections: ["MONTREAL", "LONDON", "HOUSTON"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 9.9,
    population: 18710000,
    distanceFromSeoul: 11075
  },
  'HOUSTON': {
    name: 'Houston',
    connections: ["NEW_YORK", "MEXICO_CITY"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 10.2,
    population: 7200000,
    distanceFromSeoul: 11500
  },
  'LUSAKA': {
    name: 'Lusaka',
    connections: ["ANTANANARIVO", "HARARE"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 10.4,
    population: 3100000,
    distanceFromSeoul: 11700
  },
  'HARARE': {
    name: 'Harare',
    connections: ["LUSAKA", "ABUJA"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 10.5,
    population: 1580000,
    distanceFromSeoul: 11900
  },
  'MEXICO_CITY': {
    name: 'Mexico City',
    connections: ["MIAMI", "HOUSTON"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 10.6,
    population: 22500000,
    distanceFromSeoul: 12000
  },
  'ABUJA': {
    name: 'Abuja',
    connections: ["LAGOS", "HARARE"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 10.6,
    population: 360000,
    distanceFromSeoul: 12000
  },
  'LAGOS': {
    name: 'Lagos',
    connections: ["ABUJA", "KINSHASA"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 10.7,
    population: 17150000,
    distanceFromSeoul: 12100
  },
  'KINSHASA': {
    name: 'Kinshasa',
    connections: ["ACCRA", "LAGOS"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 10.8,
    population: 17770000,
    distanceFromSeoul: 12200
  },
  'ACCRA': {
    name: 'Accra',
    connections: ["JOHANNESBURG", "KINSHASA"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 10.8,
    population: 3400000,
    distanceFromSeoul: 12300
  },
  'JOHANNESBURG': {
    name: 'Johannesburg',
    connections: ["LUANDA", "ACCRA"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 11.0,
    population: 6100000,
    distanceFromSeoul: 12467
  },
  'LUANDA': {
    name: 'Luanda',
    connections: ["DAKAR", "JOHANNESBURG"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 11.1,
    population: 8950000,
    distanceFromSeoul: 12600
  },
  'DAKAR': {
    name: 'Dakar',
    connections: ["LUANDA", "DURBAN"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 11.2,
    population: 3940000,
    distanceFromSeoul: 12800
  },
  'DURBAN': {
    name: 'Durban',
    connections: ["DAKAR", "WINDHOEK"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 11.2,
    population: 3900000,
    distanceFromSeoul: 12800
  },
  'MIAMI': {
    name: 'Miami',
    connections: ["MEXICO_CITY", "GUATEMALA_CITY"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 11.4,
    population: 6200000,
    distanceFromSeoul: 13000
  },
  'WINDHOEK': {
    name: 'Windhoek',
    connections: ["CAPE_TOWN", "DURBAN"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 11.5,
    population: 460000,
    distanceFromSeoul: 13100
  },
  'GUATEMALA_CITY': {
    name: 'Guatemala City',
    connections: ["MIAMI", "SAN_SALVADOR"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 11.8,
    population: 3200000,
    distanceFromSeoul: 13500
  },
  'CAPE_TOWN': {
    name: 'Cape Town',
    connections: ["WINDHOEK"],
    facilities: ["ST", "CA", "HC", "MS", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 11.8,
    population: 4800000,
    distanceFromSeoul: 13500
  },
  'SAN_SALVADOR': {
    name: 'San Salvador',
    connections: ["GUATEMALA_CITY", "MANAGUA"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 12.0,
    population: 1100000,
    distanceFromSeoul: 13700
  },
  'MANAGUA': {
    name: 'Managua',
    connections: ["SAN_SALVADOR", "SAN_JOSE"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 12.2,
    population: 1500000,
    distanceFromSeoul: 14000
  },
  'SAN_JOSE': {
    name: 'San José',
    connections: ["PANAMA_CITY", "MANAGUA"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 12.2,
    population: 340000,
    distanceFromSeoul: 14000
  },
  'PANAMA_CITY': {
    name: 'Panama City',
    connections: ["CARACAS", "SAN_JOSE"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 12.6,
    population: 1900000,
    distanceFromSeoul: 14500
  },
  'CARACAS': {
    name: 'Caracas',
    connections: ["BOGOTA", "PANAMA_CITY"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 12.8,
    population: 2900000,
    distanceFromSeoul: 14800
  },
  'BOGOTA': {
    name: 'Bogotá',
    connections: ["QUITO", "CARACAS"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 13.0,
    population: 11500000,
    distanceFromSeoul: 15000
  },
  'QUITO': {
    name: 'Quito',
    connections: ["BOGOTA", "LIMA"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 13.2,
    population: 2800000,
    distanceFromSeoul: 15200
  },
  'LIMA': {
    name: 'Lima',
    connections: ["QUITO", "LA_PAZ"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 13.5,
    population: 11200000,
    distanceFromSeoul: 15600
  },
  'LA_PAZ': {
    name: 'La Paz',
    connections: ["BRASILIA", "LIMA"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 13.8,
    population: 2000000,
    distanceFromSeoul: 16000
  },
  'BRASILIA': {
    name: 'Brasilia',
    connections: ["RIO_DE_JANEIRO", "LA_PAZ"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 15.2,
    population: 4800000,
    distanceFromSeoul: 17800
  },
  'RIO_DE_JANEIRO': {
    name: 'Rio de Janeiro',
    connections: ["BRASILIA", "ASUNCION"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 15.6,
    population: 13700000,
    distanceFromSeoul: 18200
  },
  'ASUNCION': {
    name: 'Asunción',
    connections: ["SAO_PAULO", "RIO_DE_JANEIRO"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 15.6,
    population: 750000,
    distanceFromSeoul: 18300
  },
  'SAO_PAULO': {
    name: 'São Paulo',
    connections: ["SANTIAGO", "ASUNCION"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 15.7,
    population: 22807000,
    distanceFromSeoul: 18400
  },
  'SANTIAGO': {
    name: 'Santiago',
    connections: ["MONTEVIDEO", "SAO_PAULO"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 16.0,
    population: 7200000,
    distanceFromSeoul: 18700
  },
  'MONTEVIDEO': {
    name: 'Montevideo',
    connections: ["SANTIAGO", "BUENOS_AIRES"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 16.4,
    population: 1900000,
    distanceFromSeoul: 19200
  },
  'BUENOS_AIRES': {
    name: 'Buenos Aires',
    connections: ["MONTEVIDEO"],
    facilities: ["ST", "VS", "CA", "HC", "RL", "MS", "BH", "SF"],
    minRank: IdolRank.LEGEND,
    difficultyMultiplier: 16.6,
    population: 15750000,
    distanceFromSeoul: 19450
  },
};

export const CITY_VIBES: Record<string, string[]> = {
  'SEOUL': ["NEON", "TRENDY", "DENSE"],
  'OSAKA': ["NEON", "TRENDY", "DENSE"],
  'SHANGHAI': ["NEON", "TRENDY", "DENSE"],
  'BEIJING': ["NEON", "TRENDY", "DENSE"],
  'TOKYO': ["NEON", "TRENDY", "DENSE"],
  'TAIPEI': ["NEON", "TRENDY", "DENSE"],
  'MACAU': ["NEON", "TRENDY", "DENSE"],
  'HONG_KONG': ["NEON", "TRENDY", "DENSE"],
  'ULAANBAATAR': ["NEON", "TRENDY", "DENSE"],
  'MANILA': ["NEON", "TRENDY", "DENSE"],
  'HANOI': ["NEON", "TRENDY", "DENSE"],
  'VIENTIANE': ["NEON", "TRENDY", "DENSE"],
  'HO_CHI_MINH_CITY': ["NEON", "TRENDY", "DENSE"],
  'PHNOM_PENH': ["NEON", "TRENDY", "DENSE"],
  'BANGKOK': ["NEON", "TRENDY", "DENSE"],
  'YANGON': ["NEON", "TRENDY", "DENSE"],
  'DHAKA': ["NEON", "TRENDY", "DENSE"],
  'THIMPHU': ["NEON", "TRENDY", "DENSE"],
  'ALMATY': ["NEON", "TRENDY", "DENSE"],
  'KATHMANDU': ["NEON", "TRENDY", "DENSE"],
  'BISHKEK': ["NEON", "TRENDY", "DENSE"],
  'KUALA_LUMPUR': ["NEON", "TRENDY", "DENSE"],
  'SINGAPORE': ["NEON", "TRENDY", "DENSE"],
  'DELHI': ["NEON", "TRENDY", "DENSE"],
  'TASHKENT': ["NEON", "TRENDY", "DENSE"],
  'DUSHANBE': ["NEON", "TRENDY", "DENSE"],
  'ISLAMABAD': ["NEON", "TRENDY", "DENSE"],
  'JAKARTA': ["NEON", "TRENDY", "DENSE"],
  'KABUL': ["NEON", "TRENDY", "DENSE"],
  'MUMBAI': ["NEON", "TRENDY", "DENSE"],
  'CHENNAI': ["NEON", "TRENDY", "DENSE"],
  'ASHGABAT': ["NEON", "TRENDY", "DENSE"],
  'BANGALORE': ["NEON", "TRENDY", "DENSE"],
  'COLOMBO': ["NEON", "TRENDY", "DENSE"],
  'KARACHI': ["NEON", "TRENDY", "DENSE"],
  'TEHRAN': ["DESERT", "PREMIUM", "MODERN"],
  'MALE': ["NEON", "TRENDY", "DENSE"],
  'MOSCOW': ["HISTORIC", "INDIE", "COOL"],
  'DUBAI': ["DESERT", "PREMIUM", "MODERN"],
  'ST_PETERSBURG': ["HISTORIC", "INDIE", "COOL"],
  'ABU_DHABI': ["DESERT", "PREMIUM", "MODERN"],
  'MUSCAT': ["DESERT", "PREMIUM", "MODERN"],
  'MANAMA': ["DESERT", "PREMIUM", "MODERN"],
  'HELSINKI': ["HISTORIC", "INDIE", "COOL"],
  'DOHA': ["DESERT", "PREMIUM", "MODERN"],
  'RIYADH': ["DESERT", "PREMIUM", "MODERN"],
  'TALLINN': ["HISTORIC", "INDIE", "COOL"],
  'BAGHDAD': ["DESERT", "PREMIUM", "MODERN"],
  'HONOLULU': ["SCENIC", "CHILL", "SUNNY"],
  'KUWAIT_CITY': ["DESERT", "PREMIUM", "MODERN"],
  'JEDDAH': ["DESERT", "PREMIUM", "MODERN"],
  'KIEV': ["HISTORIC", "INDIE", "COOL"],
  'RIGA': ["HISTORIC", "INDIE", "COOL"],
  'VILNIUS': ["HISTORIC", "INDIE", "COOL"],
  'SANNA': ["DESERT", "PREMIUM", "MODERN"],
  'MINSK': ["HISTORIC", "INDIE", "COOL"],
  'STOCKHOLM': ["HISTORIC", "INDIE", "COOL"],
  'ADEN': ["DESERT", "PREMIUM", "MODERN"],
  'ANKARA': ["HISTORIC", "INDIE", "COOL"],
  'PERTH': ["SCENIC", "CHILL", "SUNNY"],
  'AMMAN': ["DESERT", "PREMIUM", "MODERN"],
  'DAMASCUS': ["DESERT", "PREMIUM", "MODERN"],
  'WARSAW': ["HISTORIC", "INDIE", "COOL"],
  'BEIRUT': ["DESERT", "PREMIUM", "MODERN"],
  'ISTANBUL': ["HISTORIC", "INDIE", "COOL"],
  'TEL_AVIV': ["DESERT", "PREMIUM", "MODERN"],
  'BRISBANE': ["SCENIC", "CHILL", "SUNNY"],
  'BUCHAREST': ["HISTORIC", "INDIE", "COOL"],
  'OSLO': ["HISTORIC", "INDIE", "COOL"],
  'BERLIN': ["HISTORIC", "INDIE", "COOL"],
  'COPENHAGEN': ["HISTORIC", "INDIE", "COOL"],
  'VANCOUVER': ["URBAN", "MODERN", "VIBRANT"],
  'SOFIA': ["HISTORIC", "INDIE", "COOL"],
  'BUDAPEST': ["HISTORIC", "INDIE", "COOL"],
  'SYDNEY': ["SCENIC", "CHILL", "SUNNY"],
  'BELGRADE': ["HISTORIC", "INDIE", "COOL"],
  'MUNICH': ["HISTORIC", "INDIE", "COOL"],
  'VIENNA': ["HISTORIC", "INDIE", "COOL"],
  'CAIRO': ["WARM", "TRADITIONAL", "VIBRANT"],
  'ATHENS': ["HISTORIC", "INDIE", "COOL"],
  'ALEXANDRIA': ["WARM", "TRADITIONAL", "VIBRANT"],
  'PRAGUE': ["HISTORIC", "INDIE", "COOL"],
  'MELBOURNE': ["SCENIC", "CHILL", "SUNNY"],
  'FRANKFURT': ["HISTORIC", "INDIE", "COOL"],
  'AMSTERDAM': ["HISTORIC", "INDIE", "COOL"],
  'BRUSSELS': ["HISTORIC", "INDIE", "COOL"],
  'ZURICH': ["HISTORIC", "INDIE", "COOL"],
  'LONDON': ["HISTORIC", "INDIE", "COOL"],
  'MILAN': ["HISTORIC", "INDIE", "COOL"],
  'GENEVA': ["HISTORIC", "INDIE", "COOL"],
  'ROME': ["HISTORIC", "INDIE", "COOL"],
  'PARIS': ["HISTORIC", "INDIE", "COOL"],
  'TRIPOLI': ["WARM", "TRADITIONAL", "VIBRANT"],
  'LYON': ["HISTORIC", "INDIE", "COOL"],
  'MANCHESTER': ["HISTORIC", "INDIE", "COOL"],
  'DUBLIN': ["HISTORIC", "INDIE", "COOL"],
  'KHARTOUM': ["WARM", "TRADITIONAL", "VIBRANT"],
  'TUNIS': ["WARM", "TRADITIONAL", "VIBRANT"],
  'ADDIS_ABABA': ["WARM", "TRADITIONAL", "VIBRANT"],
  'ALGIERS': ["WARM", "TRADITIONAL", "VIBRANT"],
  'AUCKLAND': ["SCENIC", "CHILL", "SUNNY"],
  'LOS_ANGELES': ["URBAN", "MODERN", "VIBRANT"],
  'WELLINGTON': ["SCENIC", "CHILL", "SUNNY"],
  'BARCELONA': ["HISTORIC", "INDIE", "COOL"],
  'MOGADISHU': ["WARM", "TRADITIONAL", "VIBRANT"],
  'MADRID': ["HISTORIC", "INDIE", "COOL"],
  'CASABLANCA': ["WARM", "TRADITIONAL", "VIBRANT"],
  'NAIROBI': ["WARM", "TRADITIONAL", "VIBRANT"],
  'LISBON': ["HISTORIC", "INDIE", "COOL"],
  'MARRAKECH': ["WARM", "TRADITIONAL", "VIBRANT"],
  'KAMPALA': ["WARM", "TRADITIONAL", "VIBRANT"],
  'PORT_LOUIS': ["WARM", "TRADITIONAL", "VIBRANT"],
  'CHICAGO': ["URBAN", "MODERN", "VIBRANT"],
  'TORONTO': ["URBAN", "MODERN", "VIBRANT"],
  'DAR_ES_SALAAM': ["WARM", "TRADITIONAL", "VIBRANT"],
  'MONTREAL': ["URBAN", "MODERN", "VIBRANT"],
  'ANTANANARIVO': ["WARM", "TRADITIONAL", "VIBRANT"],
  'NEW_YORK': ["URBAN", "MODERN", "VIBRANT"],
  'HOUSTON': ["URBAN", "MODERN", "VIBRANT"],
  'LUSAKA': ["WARM", "TRADITIONAL", "VIBRANT"],
  'HARARE': ["WARM", "TRADITIONAL", "VIBRANT"],
  'MEXICO_CITY': ["URBAN", "MODERN", "VIBRANT"],
  'ABUJA': ["WARM", "TRADITIONAL", "VIBRANT"],
  'LAGOS': ["WARM", "TRADITIONAL", "VIBRANT"],
  'KINSHASA': ["WARM", "TRADITIONAL", "VIBRANT"],
  'ACCRA': ["WARM", "TRADITIONAL", "VIBRANT"],
  'JOHANNESBURG': ["WARM", "TRADITIONAL", "VIBRANT"],
  'LUANDA': ["WARM", "TRADITIONAL", "VIBRANT"],
  'DAKAR': ["WARM", "TRADITIONAL", "VIBRANT"],
  'DURBAN': ["WARM", "TRADITIONAL", "VIBRANT"],
  'MIAMI': ["URBAN", "MODERN", "VIBRANT"],
  'WINDHOEK': ["WARM", "TRADITIONAL", "VIBRANT"],
  'GUATEMALA_CITY': ["URBAN", "MODERN", "VIBRANT"],
  'CAPE_TOWN': ["WARM", "TRADITIONAL", "VIBRANT"],
  'SAN_SALVADOR': ["URBAN", "MODERN", "VIBRANT"],
  'MANAGUA': ["URBAN", "MODERN", "VIBRANT"],
  'SAN_JOSE': ["URBAN", "MODERN", "VIBRANT"],
  'PANAMA_CITY': ["URBAN", "MODERN", "VIBRANT"],
  'CARACAS': ["URBAN", "MODERN", "VIBRANT"],
  'BOGOTA': ["URBAN", "MODERN", "VIBRANT"],
  'QUITO': ["URBAN", "MODERN", "VIBRANT"],
  'LIMA': ["URBAN", "MODERN", "VIBRANT"],
  'LA_PAZ': ["URBAN", "MODERN", "VIBRANT"],
  'BRASILIA': ["URBAN", "MODERN", "VIBRANT"],
  'RIO_DE_JANEIRO': ["URBAN", "MODERN", "VIBRANT"],
  'ASUNCION': ["URBAN", "MODERN", "VIBRANT"],
  'SAO_PAULO': ["URBAN", "MODERN", "VIBRANT"],
  'SANTIAGO': ["URBAN", "MODERN", "VIBRANT"],
  'MONTEVIDEO': ["URBAN", "MODERN", "VIBRANT"],
  'BUENOS_AIRES': ["URBAN", "MODERN", "VIBRANT"],
};
